import { Box } from '@robocorp/components';
import { styled } from '@robocorp/theme';
import { ExtractProps } from '~/types';

const TextOverflow = styled(Box)<ExtractProps<typeof Box>>`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default TextOverflow;
